export const LOGIN = "/login";
export const REGISTER = "/register";
export const SIGNUP = "/signup";
export const SIGNUP_PROCESS = "/signup-process";
export const ROOT = "/";
export const DASHBOARD = "/dashboard";
export const UPLOAD = "/upload";
export const EBAY = "/ebay";
export const EBAY_SYNC = "/ebay-sync";
export const EBAY_SYNC_DETAIL = "/ebay-sync/:syncRunId";
export const BATCHES = "/batches";
export const GLOBAL_PRESETS = "/global-presets";
export const TITLE_BUILDER = "/title-builder";
export const POLICIES = "/policies";
export const SETTINGS = "/settings";
export const PROFILE = "/profile";
export const PROFILE_SETTINGS = "/profile-settings";
export const PAYMENT_DETAILS = "/payment-details";
export const AUTH_SUCCESS = "/auth-success";
export const FLOWMAIL_DASHBOARD = "/flowmail-dashboard";
export const TEST_PAGE = "/test-page";
